import { apiResource } from '../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

// Type minimal pour un client legacy
export interface LegacyClientData {
	legacyId: number;
	label: string;
	externalKey?: string;
	externalStatus: 'NOT_IMPORTED' | 'IMPORTED' | 'MANUALLY_LINKED' | 'IGNORED';
	corelysId?: number;
}

const baseApi = apiResource<LegacyClientData>('legacy/fincet/clients');

const apiBaseUrl = getApiBaseUrl();
export const API_URL = apiBaseUrl + '/v2';
import apiFetch from 'common/services/apiFetch';

async function request<T>(
	url: string,
	method: string,
	token: string,
	body?: Partial<T>
): Promise<T> {
	const res = await apiFetch(`${API_URL}${url}`, {
		method,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: body ? JSON.stringify(body) : undefined,
	});
	if (!res.ok) throw new Error(`Failed to ${method} ${url}`);
	return method === 'DELETE' ? (undefined as unknown as T) : res.json();
}

const baseUrl = `/legacy/fincet/clients`;

export const legacyFincetClientsApi = {
	...baseApi, // CRUD générique

	import: (legacyId: number, token: string) =>
		request<{ corelysId: number }>(
			`${baseUrl}/import/${legacyId}`,
			'POST',
			token
		),
};
